/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {callTool} from '../api'

export const useMutationCallTool = createReactQueryMutationHook('callTool', callTool)
